import React, { createContext, useContext } from "react";
import useSocket from "src/hooks/socket.hook";

const SocketContext = createContext<ReturnType<typeof useSocket> | null>(null);

export const SocketProvider: React.FC<{ defaultToken?: string; children: React.ReactNode }> = ({
	defaultToken,
	children,
}) => {
	const socketState = useSocket(defaultToken);
	return <SocketContext.Provider value={socketState}>{children}</SocketContext.Provider>;
};

export const useSocketContext = () => {
	const ctx = useContext(SocketContext);
	if (!ctx) {
		throw new Error("useSocketContext must be used inside <SocketProvider>");
	}
	return ctx;
};
